import { CSSProperties, memo } from "react";

// Local copies from https://github.com/HatScripts/circle-flags (MIT).
import ae from "../../assets/fiat-flags/ae.svg";
import au from "../../assets/fiat-flags/au.svg";
import br from "../../assets/fiat-flags/br.svg";
import ca from "../../assets/fiat-flags/ca.svg";
import ch from "../../assets/fiat-flags/ch.svg";
import cl from "../../assets/fiat-flags/cl.svg";
import co from "../../assets/fiat-flags/co.svg";
import cz from "../../assets/fiat-flags/cz.svg";
import dk from "../../assets/fiat-flags/dk.svg";
import eu from "../../assets/fiat-flags/eu.svg";
import gb from "../../assets/fiat-flags/gb.svg";
import hk from "../../assets/fiat-flags/hk.svg";
import id from "../../assets/fiat-flags/id.svg";
import jp from "../../assets/fiat-flags/jp.svg";
import mx from "../../assets/fiat-flags/mx.svg";
import no from "../../assets/fiat-flags/no.svg";
import nz from "../../assets/fiat-flags/nz.svg";
import ph from "../../assets/fiat-flags/ph.svg";
import pl from "../../assets/fiat-flags/pl.svg";
import qa from "../../assets/fiat-flags/qa.svg";
import ro from "../../assets/fiat-flags/ro.svg";
import sa from "../../assets/fiat-flags/sa.svg";
import se from "../../assets/fiat-flags/se.svg";
import sg from "../../assets/fiat-flags/sg.svg";
import th from "../../assets/fiat-flags/th.svg";
import tr from "../../assets/fiat-flags/tr.svg";
import tw from "../../assets/fiat-flags/tw.svg";
import us from "../../assets/fiat-flags/us.svg";
import vn from "../../assets/fiat-flags/vn.svg";
import za from "../../assets/fiat-flags/za.svg";

type FiatIconProps = {
  currency: string;
  className?: string;
  height?: number | string;
  width?: number | string;
  style?: CSSProperties;
  title?: string;
  role?: string;
  "aria-hidden"?: boolean | "true" | "false";
  "aria-label"?: string;
};

const CURRENCY_FLAGS: Record<string, string> = {
  AED: ae,
  AUD: au,
  BRL: br,
  CAD: ca,
  CHF: ch,
  CLP: cl,
  COP: co,
  CZK: cz,
  DKK: dk,
  EUR: eu,
  GBP: gb,
  HKD: hk,
  IDR: id,
  JPY: jp,
  MXN: mx,
  NOK: no,
  NZD: nz,
  PHP: ph,
  PLN: pl,
  QAR: qa,
  RON: ro,
  SAR: sa,
  SEK: se,
  SGD: sg,
  THB: th,
  TRY: tr,
  TWD: tw,
  USD: us,
  VND: vn,
  ZAR: za,
};

const _FiatIcon = ({ currency, ...props }: FiatIconProps) => {
  const normalizedCurrency = currency.trim().toUpperCase();
  const src = CURRENCY_FLAGS[normalizedCurrency];

  if (!src) return null;

  return (
    <img
      {...props}
      src={src}
      alt=""
      draggable={false}
      data-currency={normalizedCurrency}
    />
  );
};

export const FiatIcon = memo(_FiatIcon);
FiatIcon.displayName = "FiatIcon";
